import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';

import { AppView } from './components/AppView';
import { GlobalStyle } from './GlobalStyle';

const init = () => {
    ReactDOM.render(
        <>
            <GlobalStyle />
            <AppView />
        </>,
        document.getElementById('root')
    );
};

export { init };
